<template>
  <div>
    <!--    <div style="background: #1E3758">-->
    <div>
      <!--            <img class="logo" src="./assets/logo.png"/>-->
      <div class="Sys-warp top-container">


        <span style="font-size: 24px;color: black;font-weight: bold">成都龙潭工业机器人产业功能区楼宇平台</span>
        <el-menu active-text-color="#0875E6" :index="activeIndex" :default-active="activeIndex"
                 style="background-color: transparent"
                 mode="horizontal">
          <el-menu-item index="/home" @click="jumpHome" class="nav_font">首页</el-menu-item>
          <el-menu-item index="/InApply" @click="jumpInApply" class="nav_font">企业入驻申请</el-menu-item>
          <el-menu-item index="/ChangeApply" @click="jumpChangeApply" class="nav_font">工商变更申请</el-menu-item>
<!--          <el-menu-item index="/ProofForUseApply" @click="jumpProofForUseApply" class="nav_font">房屋使用证明申请</el-menu-item>-->
          <el-menu-item index="/query" @click="jumpQuery" class="nav_font">企业业务查询
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <router-view :style="'min-height: '+vdaH" v-if="vdaH!=null">

    </router-view>
    <div class="bottom">
      <p style="position:relative;top: 48px">
        <!--        <router-link to='/aboutUs' tag="span"><label style="cursor: pointer">关于我们</label>-->
        <!--        </router-link>-->
        <!--                <label-->
        <!--                        style="padding-left: 30px;cursor:pointer">-->
        <!--                    <router-link to='/privacyPolicy' tag="span">隐私政策</router-link>-->
        <!--                </label>-->
        <!--                <router-link to="/userPolicy" tag="span">-->
        <!--                    <label-->
        <!--                            style="padding-left: 30px;cursor:pointer;">用户协议</label></router-link>-->
        <!--        <router-link to='/contactUs' tag="span">-->
        <!--          <label-->
        <!--              style="padding-left: 30px;cursor:pointer">联系我们</label>　　　-->
        <!--        </router-link>-->
        　　　
      </p>
      <p style="position:relative;top: 77px">成都云苏信息科技有限公司提供技术支持</p>
      <p style="position:relative;top: 77px;padding-top: 10px">版权所有ICP证：<a href="http://beian.miit.gov.cn/"
                                                                           target="_blank" style="color: white">蜀ICP备2021009425号-2</a>
      </p>
    </div>

    <change-apply-verify-company-info-dialog v-if="verifyDialogVisible"
                                             ref="verifyDialog"></change-apply-verify-company-info-dialog>
    <in-apply-verify-company-info-dialog v-if="inApplyVerifyDialogVisible"
                                         ref="inApplyVerifyDialog"></in-apply-verify-company-info-dialog>

  </div>

</template>
<script>
import {
  login,
  getLoginUserInfo,
  logout,
  getCategory,
  sendVerifyCode,
  resetPwd
} from '@/api/api'
import {getVerifyCode} from "./api/api";
import ChangeApplyVerifyCompanyInfoDialog from "@/component/ChangeApplyVerifyCompanyInfoDialog";
import InApplyVerifyCompanyInfoDialog from "@/component/InApplyVerifyCompanyInfoDialog";
import constant from "@/utils/constant";

export default {
  data() {
    return {
      activeIndex: '/home',
      vdaH: null,
      verifyDialogVisible: false,
      inApplyVerifyDialogVisible: false
    }
  },
  components: {
    ChangeApplyVerifyCompanyInfoDialog,
    InApplyVerifyCompanyInfoDialog
  },
  watch: {
    $route(to, from) {
      // console.log(to,from)
      this.handleRoutePath();
    }
  },
  created() {
    this.handleRoutePath();
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    this.vdaH = h - 269 + 'px';
  },
  methods: {
    handleRoutePath: function () {
      this.activeIndex = this.$route.path;
      console.log(this.activeIndex)
    },

    jumpHome() {
      this.$router.push({
        name: 'home',
      });
    },
    jumpInApply() {
      this.inApplyVerifyDialogVisible = true
      this.$nextTick(() => {
        this.$refs.inApplyVerifyDialog.init()
      })
    },
    jumpChangeApply() {
      this.$confirm('原注册地在功能区外的企业，请进行入驻申请，原注册地在功能区内的企业，可以进行工商变更申请，确定发起工商变更申请吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.verifyDialogVisible = true
        this.$nextTick(() => {
          this.$refs.verifyDialog.init(constant.BUSINESS_TYPE_CHANGE)
        })
      }).catch(() => {
      });
    },
    jumpProofForUseApply() {
      this.verifyDialogVisible = true
      this.$nextTick(() => {
        this.$refs.verifyDialog.init(constant.BUSINESS_TYPE_PROOF_OF_USE)
      })
    },
    jumpQuery() {
      this.$router.push({
        name: 'Query',
      });
    },
  }
}
</script>
<style>
body {
  margin: 0px 0px 0px 0px;
  font-weight: 400;
  overflow-y: scroll;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

div {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

p {
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.Sys-warp {
  width: 1200px;
  overflow: hidden;
  margin: auto;
}

.top-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  background-color: #FFFFFF;
}


.nav_font {
  font-size: 16px;
  font-weight: bold;
}

.bottom {
  background-color: #3C3C3C;
  width: 100%;
  height: 181px;
  text-align: center;
  color: white;
  font-size: 16px;
  white-space: nowrap;
}

/*去除navMenu下划线*/
.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  background-color: transparent;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  background-color: transparent;
}

.el-menu.el-menu--horizontal {
  border: none;
  background-color: transparent;
}

.title {
  font-size: 34px;
  font-weight: bold;
  color: #4F76B6;
  text-align: center;
  width: 100%;
  margin-top: 65px;
  margin-bottom: 65px;
}

.image-hint {
  color: #118DEF;
}

.tips {
  color: #fd8208;
  line-height: 20px;
  margin-top: 10px;
}
</style>
